<template>
  <div class="header">
    <div class="flex">
      <div class="nav">
        <router-link class="item flex" exact active-class="active" to="/"
          >首页</router-link
        >
        <router-link class="item flex" active-class="active" to="/resourceList"
          >资源列表</router-link
        >
      </div>
      <!-- <div class="logo">
        <img src="@/assets/img/common/logo.png" alt="" />
      </div> -->
    </div>
    <div class="text_title flex">
      <img src="@/assets/img/common/text_title.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.header {
  position: relative;
}
.nav {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  .item {
    width: 120px;
    height: 48px;
    background: #bfc9d2;
    border-radius: 0px 0px 8px 8px;
    letter-spacing: 2px;
    font-size: 18px;
    color: #333;
    margin: 0 20px;
  }
  .active {
    background: @theme;
    color: #fff;
  }
}
.logo {
  position: absolute;
  top: 10px;
  right: 0;
}
.text_title {
  padding-top: 100px;
  margin-bottom: 40px;
}
</style>
